(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marshall-scrolling-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Get references to the header and scrolling text elements
  const header = document.getElementById('stickyHeader');
  const scrollingBanner = document.querySelector('.scrolling-text-banner');
  
  if (scrollingBanner && header) {
    // Add a class to help with styling
    scrollingBanner.classList.add('sticky-scrolling-banner');
    
    // Store original position of the scrolling banner for reference
    const bannerOriginalPosition = scrollingBanner.getBoundingClientRect().top + window.pageYOffset;
    const bannerHeight = scrollingBanner.offsetHeight;
    
    // Create a placeholder to prevent content jump
    const placeholder = document.createElement('div');
    placeholder.classList.add('scrolling-banner-placeholder');
    placeholder.style.height = '0px';
    scrollingBanner.parentNode.insertBefore(placeholder, scrollingBanner);
    
    // Handle scroll events
    let lastScrollY = window.scrollY;
    
    function updateScrollingBanner() {
      const currentScrollY = window.scrollY;
      const headerHeight = header.offsetHeight;
      const headerVisible = !header.classList.contains('hide-scroll-down');
      
      // When scrolled past the original position of the banner
      if (currentScrollY >= bannerOriginalPosition) {
        if (!scrollingBanner.classList.contains('is-sticky')) {
          scrollingBanner.classList.add('is-sticky');
          placeholder.style.height = bannerHeight + 'px';
        }
        
        // If header is visible (scrolling up), position banner below header
        if (headerVisible) {
          scrollingBanner.style.top = headerHeight + 'px';
        } 
        // If header is hidden (scrolling down), position banner at the top
        else {
          scrollingBanner.style.top = '0';
        }
      } else {
        // Reset when scrolled back to the top
        scrollingBanner.classList.remove('is-sticky');
        placeholder.style.height = '0px';
        scrollingBanner.style.top = '';
      }
      
      lastScrollY = currentScrollY;
    }
    
    // Initial update
    updateScrollingBanner();
    
    // Listen for scroll events
    window.addEventListener('scroll', updateScrollingBanner);
    window.addEventListener('resize', function() {
      // Recalculate banner height on resize
      if (scrollingBanner.classList.contains('is-sticky')) {
        placeholder.style.height = scrollingBanner.offsetHeight + 'px';
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
